/** a function to make sure to get type errors if an object is not never, i.e., forget to check other types */
export const assertNever = (obj) => {
    throw new Error(`should have never type: ${JSON.stringify(obj)}`);
};
